module.exports = __webpack_public_path__ + "img/mySchoolLogo300x502.52debd05.png";